import moment from 'moment';
import { toastr } from 'react-redux-toastr';

//Actions
import { shopCommonModalAction } from '../../../../../actions/modalActions';
import { setLoaderStart, setLoaderComplete } from '../../../../../actions/loader/loader';

const submit = async (values, dispatch) => {
    dispatch(setLoaderStart("isCompleletBookingPDFLoading"));
    try {
        let startDate = moment(values.startDate), endDate = moment(values.endDate);

        if (!startDate || !startDate.isValid() || !endDate || !endDate.isValid()) {
            toastr.error('Error', 'Invalid dates');
            return;
        }

        const anchorTag = document.createElement('a');
        anchorTag.href = `/download-pdf?start=${startDate.format('YYYY-MM-DD')}&end=${endDate.format('YYYY-MM-DD')}&type=${values.type}&pdfType=completeBooking&fileName=order-management-complete-booking-${startDate.format('DD/MM/YYYY' + ' to ') + endDate.format('DD/MM/YYYY')}.pdf&filePath=pdf/shop`;
        document.body.appendChild(anchorTag);
        anchorTag.click();
        document.body.removeChild(anchorTag);

        dispatch(setLoaderComplete("isCompleletBookingPDFLoading"));
        dispatch(shopCommonModalAction({ name: "isCompleteBookingPDFModal", value: false }));
    } catch (error) {
        toastr.error("Error!", error.message);
        dispatch(setLoaderComplete("isCompleletBookingPDFLoading"));
    }
};

export default submit;